var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "tbody",
    { staticClass: "interactable" },
    [
      _vm._l(_vm.h.rows, function (row) {
        return [
          _c("HitRow", {
            key: `${row.annotatedField?.id}-hit`,
            class: {
              open: _vm.open,
              interactable: !_vm.disableDetails && !_vm.disabled,
              "foreign-hit": row.isForeign,
            },
            attrs: {
              data: row,
              mainAnnotation: _vm.mainAnnotation,
              otherAnnotations: _vm.otherAnnotations,
              metadata: _vm.metadata,
              dir: _vm.dir,
              html: _vm.html,
              hoverMatchInfos: _vm.hoverMatchInfos,
              isParallel: _vm.isParallel,
            },
            on: {
              hover: function ($event) {
                return _vm.hover($event)
              },
              unhover: function ($event) {
                return _vm.unhover()
              },
            },
            nativeOn: {
              click: function ($event) {
                return _vm.clickNative()
              },
            },
          }),
          _vm._v(" "),
          !_vm.disableDetails
            ? _c("HitRowDetails", {
                key: `${row.annotatedField?.id}-details`,
                attrs: {
                  colspan: _vm.colspan,
                  data: row,
                  open: _vm.open,
                  mainAnnotation: _vm.mainAnnotation,
                  detailedAnnotations: _vm.detailedAnnotations,
                  depTreeAnnotations: _vm.depTreeAnnotations,
                  dir: _vm.dir,
                  html: _vm.html,
                  isParallel: _vm.isParallel,
                  hoverMatchInfos: _vm.hoverMatchInfos,
                },
                on: {
                  hover: function ($event) {
                    return _vm.hover($event)
                  },
                  unhover: function ($event) {
                    return _vm.unhover()
                  },
                },
              })
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }